<template>
  <div>
    <div class="row justify-content-end align-items-end">
      <div class="col"></div>
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button @click="$router.push({ name: 'customers-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i>
          Créer un nouveau client
        </button>
      </div>
    </div>
    <br />
    <vue-data-table :headers="headers" :data="customers" :buttons="buttons" :summableColumns="summableColumns"
      :itemsPerPage="10">
      <!-- Custom template for blocked status -->
      <template #cell-blocked="{ row }">
        <span :class="{
          'badge bg-danger': row.blocked,
          'badge bg-success': !row.blocked
        }">
          {{ row.blocked ? 'Bloqué' : 'Autorisé' }}
        </span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      headers: [
        { label: "Référence", field: "reference", class: "text-center" },
        { label: "Nom Complet", field: "fullName", class: "text-left" },
        { label: "Téléphone", field: "phone", class: "text-right" },
        { label: "Nom Commercial", field: "society", class: "text-left" },
        { label: "Max Impayé", field: "maxUnpaid", class: "text-right" },
        { label: "ICE", field: "ice", class: "text-left" },
        { label: "IF", field: "if", class: "text-left" },
        { label: "Adresse", field: "address", class: "text-left" },
        { label: "Ville", field: "city", class: "text-left" },
        { label: "Remarques", field: "remark", class: "text-left" },
        { label: "Statut", field: "blocked", class: "text-center" },
        { label: "Créé le", field: "created_at", class: "text-center" },
      ],
      buttons: [
        {
          label: "Edit",
          icon: "bi bi-pencil",
          class: "btn-primary",
          action: (row) => this.$router.push({
            name: "customers-edit",
            params: { reference: row.reference }
          }),
        },
        {
          label: "Delete",
          icon: "bi bi-trash",
          class: "btn-danger",
          action: (row) => this.remove(row.reference),
        },
      ],
      summableColumns: [
        { field: "balance", class: "text-right font-weight-bold" },
      ],
    };
  },
  computed: {
    ...mapGetters("customer", {
      customers: "getCustomers",
    }),
  },
  mounted() {
    this.$store.dispatch("customer/getAll");
  },
  methods: {
    async remove(reference) {
      await this.$store.dispatch("customer/destroy", reference);
  
    },
    async refresh() {
      await this.$store.dispatch("customer/getAll");
    },
  },
};
</script>

<style scoped>
.badge {
  padding: 0.5em 0.75em;
  font-size: 0.85em;
  font-weight: 500;
}
</style>